/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'

import './Footer.scss'

import { Link } from 'react-router-dom'

import homeIcon from  '../../assets/svg/homeIcon.svg'
import cardIcon from '../../assets/svg/cardIcon.svg'
import orderIcon from '../../assets/svg/orderIcon.svg'
import profileIcon from '../../assets/svg/profileIcon.svg'

import homeSelectIcon from  '../../assets/svg/homeSelectIcon.svg'
import cardSelectIcon from '../../assets/svg/cardSelectIcon.svg'
import orderSelectIcon from '../../assets/svg/orderSelectIcon.svg'
import profileSelectIcon from '../../assets/svg/profileSelectIcon.svg'

import { useSelector, useStore } from 'react-redux'

export default function index({ page }) {
  const basket = useSelector(state => state.basket)
  const stores = useStore()

  const [countBasket, setCountBasket] = useState(0)
  
  useEffect(() => {
    setCountBasket(basket.length)
  }, [basket.length, stores])

  return (
    <div id='footer'>
      <div className='footerBody'>
        <Link to='/menu'>
          <img src={page === 'home' ? homeSelectIcon : homeIcon} alt='homeIcon' />
          <span className={page === 'home' ? 'spanSelect' : ''}>خانه</span>
        </Link>
        <Link to='/card'>
          <img src={page === 'card' ? cardSelectIcon : cardIcon} alt='cardIcon' />
          <span className='cardCount' style={page === 'card' ? { backgroundColor: '#ff4d03' } : { backgroundColor: '' }}>{countBasket}</span>
          <span className={page === 'card' ? 'spanSelect' : ''}>سبد خرید</span>
        </Link>
        <Link to='/order'>
          <img src={page === 'order' ? orderSelectIcon : orderIcon} alt='orderIcon' />
          <span className={page === 'order' ? 'spanSelect' : ''}>سفارشات</span>
        </Link>
        <Link to='/login'>
          <img src={page === 'profile' ? profileSelectIcon : profileIcon} alt='profileIcon' />
          <span className={page === 'profile' ? 'spanSelect' : ''}>پروفایل</span>
        </Link>
      </div>
    </div>
  )
}
